// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-LRURoc","spinner-spin":"spinner-spin-EwxIam","spinnerSpin":"spinner-spin-EwxIam"};